module.exports = __webpack_public_path__ + "img/computer.e8e936e7.svg";